<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-add-tab-info">

      <div class="mt-5">
            <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">
                <tab-content :title="$t('MODULES.basic_data')" class="mb-5" icon="feather icon-home">

                    <!-- tab 1 content -->
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mt-5">
                            <vs-input :label="$t('MODULES.name')" v-model="name" class="w-full" :disabled="true" />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-5">
                            <vs-input :label="$t('MODULES.prefix')"  v-model="prefix" class="w-full" maxLength="3" :disabled="true" @input="setPrefix"/>
                        </div>
                        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
                            <vs-select v-model="menu" class="w-full select-large" label="Grupo do menu">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in menuOptions" class="w-full" />
                            </vs-select>
                        </div> -->
                        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
                            <vs-input type="email" label="Título do menu"  v-model="email" class="w-full" />
                        </div> -->
                        <div class="vx-col md:w-1/4 w-full" v-show="moduleType.name !== 'Único registro'">
                          <div class="mt-4">
                            <label class="vs-input--label">{{ $t('MODULES.usersCanAssignRecordsTo') }}</label>
                            <v-select v-model="canAssignValue" label="label" disabled :clearable="false" :options="canAssignOptions" name="can_view" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/4 w-full" v-show="moduleType.name !== 'Único registro'">
                          <div class="mt-4">
                            <label class="vs-input--label">{{  $t('MODULES.usersCanViewRecordsOf') }}</label>
                            <v-select v-model="canViewValue" :clearable="false" disabled :options="canViewOptions"  name="can_assign" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-5">
                          <label class="vs-input--label">{{ $t('MODULES.columnsInForm') }}</label>
                          <v-select v-model="columnsOnForm" :options="columnsOnFormOptions" :disabled="true" label="name"/>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-5">
                          <label class="vs-input--label">{{ $t('MODULES.moduleType') }}</label>
                          <v-select v-model="moduleType" :options="moduleTypes" label="name" :disabled="true"/>
                        </div>
                         <div class="vx-col md:w-1/2 w-full mt-5">
                            <label class="vs-input--label">{{ $t('MODULES.rowsPerPage') }}</label>
                            <v-select
                              v-model="linesByPage"
                              :options="linesByPageOptions"
                              label="name"
                              :disabled="true"
                            />
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-5">
                          <label class="vs-input--label">{{ $t('MODULES.icon') }}</label>
                          <v-select
                              class="icon-select"
                              v-model="icon"
                              :options="iconOptions"
                              label="name"
                              :disabled="true"
                            >
                            <template v-slot:option="option">
                              <feather-icon :icon="option.value" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"/> {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                        <div class="vx-col md:w-1/1 w-full mt-5">
                          <label class="vs-input--label">{{ $t('MODULES.requiresAuthentication') }}</label>
                          <ul class="con-s w-full mb-2">
                            <li>
                              <vs-switch v-model="requireAuthentication" :disabled="true" class="mt-2" />
                            </li>
                          </ul>
                        </div>
                        <div class="vx-col md:w-1/1 w-full" style="margin-top: -10px!important;">
                          <vs-textarea v-model="description" :label="$t('MODULES.description')" :disabled="true" class="mb-0 md:mt-10 mt-6" rows="3" />
                        </div>
                    </div>
                </tab-content>

                <!-- tab 2 content -->
                <tab-content :title="$t('MODULES.appearance')" class="mb-5" icon="feather icon-camera">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.striped_table')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.manageDisplayedRows')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.searchFieldInTable')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.additionalInformation')}`" />
                            </vx-input-group>
                        </div>
                    </div>
                </tab-content>

                <!-- tab 3 content -->
                <tab-content :title="$t('MODULES.exportation')" class="mb-5" icon="feather icon-download">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.exportTableToPDF')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.exportTableToExcel')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.exportTableToCSV')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.copyTableData')}`" />
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col md:w-1/4 w-full">
                      <label for="" class="vs-input--label"></label>
                        <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                          <template slot="prepend">
                            <div class="prepend-text">
                              <vs-switch v-model="print" />
                            </div>
                          </template>

                          <vs-input :value="`${$t('MODULES.print')}`" />
                        </vx-input-group>
                      </div>
                      <div class="vx-col md:w-1/4 w-full" v-if="print">
                        <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                          <vs-input v-model="printButtonLabel" label="Label do botão" />
                        </vx-input-group>
                      </div>
                      <div class="vx-col" v-if="print">
                        <label for="" class="vs-input--label">{{ $t('MODULES.maximumTimeout') }}</label>
                        <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                          <vs-input-number v-model="maxPrintTimeout" :min="10"/>
                        </vx-input-group>
                      </div>
                    </div>
                </tab-content>

                <!-- tab 4 content -->
                <tab-content :title="$t('MODULES.list')" class="mb-5" icon="feather icon-list">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.minimizedLists')}`" />
                            </vx-input-group>

                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.addLists')}`" />
                            </vx-input-group>
                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                             <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                              <template slot="prepend">
                                <div class="prepend-text">
                                  <vs-switch v-model="tableStripped" :disabled="true" />
                                </div>
                              </template>

                              <vs-input :value="`${$t('MODULES.displayLists')}`" />
                            </vx-input-group>

                        </div>
                    </div>
                </tab-content>
            </form-wizard>
            <br><br>
        </div>
      </div>

    <!-- Save & Reset Button -->
    <!-- <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/users')">Cancel</vs-button>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import vSelect from 'vue-select'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components: {
    vSelect,
    FormWizard,
    TabContent
  },
  data () {
    return {
      name: '',
      prefix: '',
      icon: null,
      iconOptions: [],
      moduleType: null,
      moduleTypes: [],
      columnsOnForm: 1,
      columnsOnFormOptions: [
        1,
        2,
        3,
        4
      ],
      linesByPage: 10,
      linesByPageOptions: [
        10,
        15,
        20,
        50
      ],
      requireAuthentication: true,
      description: '',


      city: 'new-york',
      proposalTitle: '',
      jobTitle: '',
      textarea: '',
      eventName: '',
      eventLocation: 'san-francisco',
      status: 'plannning',
      tableStripped: false,
      menu: 1,
      print: false,
      printButtonLabel: '',
      maxPrintTimeout: 10,
      canAssignValue: {},
      canViewValue: {},
      canAssignOptions: [
        { label: this.$t('MODULES.allUsers'),  value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'),  value: 2 },
        { label: this.$t('MODULES.onlySubordinateRole'),  value: 3 }
      ],
      canViewOptions: [
        { label: this.$t('MODULES.allUsers'),  value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'),  value: 2 },
        { label: this.$t('MODULES.userGroup'),  value: 3 },
        { label: this.$t('MODULES.userGroupAndSameOrSubordinateRole'),  value: 4 },
        { label: this.$t('MODULES.onlyYourUser'),  value: 5 }
      ],
      menuOptions: [
        {text: this.$t('MODULES.journalism'), value: 1},
        {text: this.$t('MODULES.apps'), value: 2}
      ],
      cityOptions: [
        {text: this.$t('MODULES.newYork'), value:'new-york'},
        {text: this.$t('MODULES.chicago'), value:'chicago'},
        {text: this.$t('MODULES.sanFrancisco'), value:'san-francisco'},
        {text: this.$t('MODULES.boston'), value:'boston'}
      ],
      statusOptions: [
        {text: this.$t('MODULES.planning'), value:'planning'},
        {text: this.$t('MODULES.inProgress'), value:'in progress'},
        {text: this.$t('MODULES.finished'), value:'finished'}
      ],
      LocationOptions: [
        {text: this.$t('MODULES.newYork'), value:'new-york'},
        {text: this.$t('MODULES.chicago'), value:'chicago'},
        {text: this.$t('MODULES.sanFrancisco'), value:'san-francisco'},
        {text: this.$t('MODULES.boston'), value:'boston'}
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
    // selectedRole: {
    //   set(obj) {
    //     this.selectedRole = obj
    //   },
    //   get() {
    //     this.selectedRole = obj
    //   }
    // }
  },
  created () {
    this.viewParameters()
  },
  methods: {
    setPrefix (val) {
      this.prefix = val.toUpperCase()
    },
    viewParameters () {
      fetch(this.$store.state.auth.api_url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          command: 'module_management_add_application_module_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (responseData) => {

              this.iconOptions = responseData.parameters.icons
              this.moduleTypes = responseData.parameters.module_types

              fetch(this.$store.state.auth.api_url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                  command: 'module_management_get_application_module_detail',
                  parameters: {
                    application_token: this.$store.state.auth.app_token,
                    session_token: this.$store.state.auth.token,
                    module_hash: this.$route.params.moduleHash
                  }
                })
              })
                .then(async (response) => {
                  if (response.status === 200) {
                    await response.json().then(async (responseData) => {

                      this.name = responseData.module.name
                      this.description = responseData.module.description
                      this.icon = {hash: responseData.module.icon_hash, name: responseData.module.icon_name, value: responseData.module.icon_value}
                      this.prefix = responseData.module.prefix
                      this.requireAuthentication = responseData.module.require_authentication
                      this.moduleType = {hash: responseData.module.type_hash, name: responseData.module.type_name}
                      this.columnsOnForm = responseData.module.columns_on_form
                      this.print = responseData.module.enable_print
                      this.printButtonLabel = responseData.module.print_button_label
                      this.maxPrintTimeout = responseData.module.max_print_timeout
                      this.canAssignValue = this.canAssignOptions.find(x => x.value === responseData.module.can_assign_type_id)
                      this.canViewValue = this.canViewOptions.find(x => x.value === responseData.module.can_view_type_id)

                    })
                  } else if (response.status == 401) {
                    this.$vs.loading.close()
                    setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                    this.$store.dispatch('auth/signOut')
                  } else {
                    this.$vs.notify({
                      title: this.$t('MODULES.hashInvalidTitle'),
                      text: this.$t('MODULES.errorCapturingModuleDetails'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                  }

                  this.$vs.loading.close()
                })
                .catch((error) => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: this.$t('MODULES.hashInvalidTitle'),
                    text: this.$t('errorRegisteringUser'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })

            })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: this.$t('MODULES.hashInvalidTitle'),
              text: this.$t('errorRegisteringUser'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }

          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.hashInvalidTitle'),
            text: this.$t('errorRegisteringUser'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },


    formSubmitted () {

    }
  }
}
</script>
<style>

.icon-select .vs__dropdown-menu {

  height: 150px !important;
}

</style>
